import Dropdown from "react-bootstrap/Dropdown";
import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from "../../store";

export enum TopMenuEnum {
  flight = "Flight",
  prePurchased = "FixedDeparture",
  packages = "TourPackages",
  activities = "Activities",
  visaChecklist = "VisaChecklist",
  hotels = "Hotels",
  bus = "Bus",
  train = "Train",
  cruise = "Cruise",
  insurance = "Insurance",
  flightsForm = "FlightsForm",
  otherEnquiry = "OtherEnquiry",
  visaEnquiry = "VisaEnquiry",
  more = "More",
}

export const moduleIcons = [
  { icon: "fas fa-plane", title: "Flight" },
  { icon: "fas fa-umbrella-beach", title: "TourPackages" },
  { icon: "fas fa-plane-departure", title: "FixedDeparture" },
  { icon: "fas fa-passport", title: "VisaChecklist" },
  { icon: "fas fa-skiing", title: "Activities" },
  { icon: "fas fa-bed", title: "Hotels" },
  { icon: "fas fa-bus", title: "Bus" },
  { icon: "fas fa-subway", title: "Train" },
  { icon: "fas fa-ship", title: "Cruise" },
  { icon: "fas fa-hand-holding-heart", title: "Insurance" },
  { icon: "fas fa-list", title: "FlightsForm" },
  { icon: "fas fa-list", title: "OtherEnquiry" },
  { icon: "fas fa-list", title: "VisaEnquiry" },
];

const printAnchor = (
  name: string,
  icon: string,
  active: boolean,
  link: string | undefined = "/"
) => {
  return (
    <a
      href={link}
      className={`form-menu-item 
      ${active && "active"}`}
    >
      <span className="nav-link">
        <i className={icon}></i>
        <span className="module-title">{name}</span>
      </span>
    </a>
  );
};

const printMenu = (moduleLink, moduleIcon, moduleName, active, moduleUrls) => {
  if (
    moduleLink === TopMenuEnum.flight ||
    moduleLink === TopMenuEnum.prePurchased ||
    moduleLink === TopMenuEnum.packages ||
    moduleLink === TopMenuEnum.visaChecklist
  ) {
    let link = moduleUrls?.modules[moduleLink];
    return printAnchor(moduleName, moduleIcon, active, link);
  }
  return (
    <Link
      to={`/${moduleLink}`}
      className={`form-menu-item 
      ${active && "active"}
      `}
    >
      <span className="nav-link">
        <i className={moduleIcon}></i>
        <span className="module-title">{moduleName}</span>
      </span>
    </Link>
  );
};

export const SingleMenuItem: React.FC<{
  title: string;
  icon: string;
  enum: TopMenuEnum;
  isDropdownMenu?: boolean;
}> = (props) => {
  const location = useLocation();
  const { moduleUrls } = useAppSelector((state) => state.siteData);

  return (
    <>
      {printMenu(
        props.enum,
        props.icon,
        props.title,
        location.pathname === `/${props.enum}`,
        moduleUrls
      )}
    </>
  );
};

export const MoreDropdownMenu: React.FC<{
  listItems: Array<any>;
}> = (props) => {
  const { moduleUrls } = useAppSelector((state) => state.siteData);

  return (
    <Dropdown
      // onClick={() => props.handleChange(props.enum)}
      className={`form-menu-item text-center md-module-title`}
    >
      <Dropdown.Toggle as={"div"} id="dropdown-basic">
        <span className="nav-link">
          <span className="module-title ">
            More <i className="fa-solid fa-angle-down"></i>
          </span>
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {props.listItems.map((item, index) => {
          if (!item.enum) {
            return;
          }

          if (
            item.enum === TopMenuEnum.flight ||
            item.enum === TopMenuEnum.prePurchased ||
            item.enum === TopMenuEnum.packages ||
            item.enum === TopMenuEnum.visaChecklist
          ) {
            let link = moduleUrls?.modules[item.enum];
            return (
              <Dropdown.Item
                className="text-dark"
                href={link}
                // to={item.enum}
                key={index}
              >
                {item.title}
              </Dropdown.Item>
            );
          }
          return (
            <Dropdown.Item
              className="text-dark"
              as={Link}
              to={item.enum}
              key={index}
            >
              {item.title}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};
